import React, { useEffect, useState } from 'react';
import { OrderExpanded } from '@services/checkout';
import { getSuccessfullyLoadedUrls } from '@utils';
import NoImagePlaceholder from '@assets/images/no-image-placeholder.png';
import { OrderItemDesktop } from './OrderItemDesktop';
import { OrderItemMobile } from './OrderItemMobile';

interface Props {
  className?: string;
  order: OrderExpanded;
  isExpanded?: boolean;
}

export const OrderItem: React.FC<Props> = ({
  className,
  order,
  isExpanded
}) => {
  const [ imageUrl, setImageUrl ] = useState(NoImagePlaceholder.src);

  useEffect(() => {
    (async (): Promise<void> => {
      const [ loadedUrl ] = await getSuccessfullyLoadedUrls([ order.lineItems[0]?.variant?.imageUrl ?? '' ]);
      setImageUrl(loadedUrl ?? NoImagePlaceholder.src);
    })();
  }, []);

  const lineItemQuantity = order.lineItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <>
      <OrderItemDesktop
        className={ className }
        imageUrl={ imageUrl }
        lineItemQuantity={ lineItemQuantity }
        order={ order }
        isExpanded={ isExpanded }
      />
      <OrderItemMobile
        imageUrl={ imageUrl }
        lineItemQuantity={ lineItemQuantity }
        order={ order }
      />
    </>
  );
};
